import React, {Component} from 'react';
import PropTypes from 'prop-types';
import signaler from '~/vendor/signaler';
import {removePreloadContainer} from '~/utils/dom';
// constants
import _featureSettings from '~/constants/FeatureFlags';
// router
import withRouter, {routerPropTypes} from '~/router/withRouter';

import './index.scss';

const propTypes = {
  router: routerPropTypes.isRequired,
  featureSettings: PropTypes.object
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class FeatureFlags extends Component {
  static displayName = 'FeatureFlags';
  static propTypes = propTypes;

  static contextTypes = {
    updateSignals: PropTypes.func
  };

  static defaultProps = {
    featureSettings: _featureSettings
  };

  state = {
    featureFlags: {}
  };

  componentDidMount() {
    signaler.featureFlags().then(flags => {
      this.setState({featureFlags: flags});
    });
    removePreloadContainer();
  }

  changeFlag = (featureName, {target: {value}}) => {
    signaler.setFeatureFlag(featureName, value);
    var featureFlags = this.state.featureFlags;
    featureFlags[featureName] = value;
    this.setState({featureFlags});
    this.context.updateSignals(featureFlags);
  };

  handleClose = () => {
    this.props.router.navigate('/');
  };

  renderFlags(flagNames) {
    return flagNames.map(flagName => {
      return (
        <option key={flagName} value={flagName}>
          {flagName}
        </option>
      );
    });
  }

  renderFeatures() {
    return Object.keys(this.props.featureSettings).map(featureName => {
      var flags = this.props.featureSettings[featureName].flags;
      var value = this.state.featureFlags[featureName];
      return (
        <div key={featureName} className="ndx-FeatureFlags-feature">
          <h3>{featureName}</h3>
          <select
            value={value}
            onChange={this.changeFlag.bind(this, featureName)}>
            <option key="none" value="">
              (none)
            </option>
            {this.renderFlags(Object.keys(flags))}
          </select>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="ndx-FeatureFlags">
        <h1>Feature Flags</h1>
        {this.renderFeatures()}
        <button
          className="ndx-Button ndx-Button--inline ndx-FeatureFlags-close"
          onClick={this.handleClose}>
          Close
        </button>
      </div>
    );
  }
}

export default withRouter(FeatureFlags);
